import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import { defaultSiteSettings, type SiteSettings } from "@/lib/site-settings";

export function SocialButtons({ className = "", settings = defaultSiteSettings() }: { className?: string; settings?: Pick<SiteSettings, "societyName" | "instagram" | "facebook" | "whatsapp"> }) {
  return (
    <ButtonGroup className={`social-icon-group ${className}`}>
      {settings.instagram && <Button asChild variant="ghost" size="icon-sm">
        <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label={`Instagram ${settings.societyName}`}><Instagram /></a>
      </Button>}
      {settings.facebook && <Button asChild variant="ghost" size="icon-sm">
        <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label={`Facebook ${settings.societyName}`}><Facebook /></a>
      </Button>}
      {settings.whatsapp && <Button asChild variant="ghost" size="icon-sm"><a href={settings.whatsapp} target="_blank" rel="noopener noreferrer" aria-label={`WhatsApp ${settings.societyName}`}><MessageCircle /></a></Button>}
    </ButtonGroup>
  );
}
